import React from "react";

const WeAreGoodIn = ({ icon, heading, text }) => {
  return (
    <div className="text-[#333333]">
      <div className="flex items-center">
        <img src={icon} alt="icon1" className="w-14 h-14" />

        <h3 className="font-bold text-xl ml-5 w-8/12">{heading}</h3>
      </div>
      <p className="text-sm text-[#333333] xl:text-md 2xl:text-lg mt-1 md:mt-5 w-11/12">{text}</p>
    </div>
  );
};

export default WeAreGoodIn;
